import {Component, OnInit, Inject} from 'ng-metadata/core';
import {MediaQueries} from "../../../infra/mediaQueries.service";

@Component({
    selector: 'prm-silent-login-alert-toast',
    templateUrl: 'components/primoExplore/silentLogin/silentLoginAlertToast/silent-login-alert-toast.html',
})

export class PrmSilentLoginAlertToast implements OnInit{
    constructor(@Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$state') private $state: angular.ui.IStateService,
                private mediaQueries: MediaQueries) {
        console.log('opened toast');
    }

    ngOnInit() {
    }

    private onDismiss() {
        this.$mdToast.hide();

    }

    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }

    private refreshState(){
        this.onDismiss();
        this.$state.reload();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/silentLogin/silentLoginAlertToast/silentLoginAlertToast.directive.ts